import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackLinkComponent } from '../../shared/components/back-link/back-link.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { LoadingSpinnerComponent } from '../../shared/components/loading-spinner/loading-spinner.component';
import { RouterModule } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MarkdownPipe } from '../../markdown.pipe';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-mcp-system-prompt',
  templateUrl: './mcp-system-prompt.component.html',
  styleUrls: ['./mcp-system-prompt.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, MatProgressSpinnerModule, MatButtonModule, MarkdownPipe, BackLinkComponent, PageHeaderComponent, LoadingSpinnerComponent],
})
export class McpSystemPromptComponent implements OnInit {
  content: string | null = null;
  isLoading = true;
  error: string | null = null;
  copyMessage: string | null = null;

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.http.get(`${environment.apiUrl}/mcp-system-prompt`, { responseType: 'text' }).subscribe({
      next: (text) => {
        this.content = text;
        this.isLoading = false;
      },
      error: () => {
        this.error = 'Failed to load MCP system prompt.';
        this.isLoading = false;
      },
    });
  }

  async copyPrompt(): Promise<void> {
    if (!this.content) {
      return;
    }
    try {
      await navigator.clipboard.writeText(this.content);
      this.copyMessage = 'System prompt copied to clipboard.';
    } catch {
      this.copyMessage = 'Copy failed. Your browser blocked clipboard access.';
    }
  }
}
